export default async function getProfileInfo(code) {
    let code_data = {
        "jsonrpc": "2.0",
        "method": "sellerClient.get_order_info",
        "id": 64899,
        "params": {
            code //"vXrLcWzRdq"
        }
    }

    return fetch('https://api.tpamotor.com/rpc', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(code_data)
    })
        .then((res) => res.json())
        .then((response) => {
            console.log('🚗 code data fetched:', response);
            return getClientInfo(response?.result?.clientID, response?.result?.sellerID)

        })
        .catch((error) => console.error('❌ Fetch error:', error))
}

async function getClientInfo(id, sellerID) {
    let code_data = {
        "jsonrpc": "2.0",
        "method": "sellerClient.get_client",
        "id": 6472,
        "params": {
            "client": {
                id
            }
        }
    }

    return fetch('https://api.tpamotor.com/rpc', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(code_data)
    })
        .then((res) => res.json())
        .then((response) => {
            console.log('🚗 client data fetched:', response);
            return {...response?.result?.client, sellerID}

        })
        .catch((error) => console.error('❌ Fetch error:', error))
}

export async function getAllParts() {


    return fetch('https://api.tpamotor.com/rpc', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "jsonrpc": "2.0",
        "method": "parts.get_parts",
        "cred": {
        },
        "id": 43210,
        "params": {
          "filters": {
            "accepted": "true"
          },
          "page": 1,
          "pageSize": 100
        }
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        console.log('🚗 Parts fetched:', response?.result?.data);
        return(response?.result?.data)
      })
      .catch((error) => console.error('❌ Fetch error:', error));

    
}

export async function getVehicleModel() {
    
    const data = {
      jsonrpc: '2.0',
      method: 'vehicle.get_vehicleModel',
      id: Math.floor(Math.random() * 1000000),
      cred: {},
      params: {}
    };


    return fetch('https://api.tpamotor.com/rpc', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        console.log('🚗 Vehicle models fetched:', response);
        // setVehicleModels(response?.result)
        return response?.result

      })
      .catch((error) => console.error('❌ Fetch error:', error));

}